'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildClientTriggers = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _ClientTriggers = require('../records/ClientTriggers');

var _ClientTriggers2 = _interopRequireDefault(_ClientTriggers);

var _ExitIntentTrigger = require('../records/ExitIntentTrigger');

var _ExitIntentTrigger2 = _interopRequireDefault(_ExitIntentTrigger);

var _ScrollPercentageTrigger = require('../records/ScrollPercentageTrigger');

var _ScrollPercentageTrigger2 = _interopRequireDefault(_ScrollPercentageTrigger);

var _TimeDelayTrigger = require('../records/TimeDelayTrigger');

var _TimeDelayTrigger2 = _interopRequireDefault(_TimeDelayTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildClientTriggers = exports.buildClientTriggers = function buildClientTriggers() {
  var clientTriggersData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new _ClientTriggers2.default({
    displayOnScrollPercentage: new _ScrollPercentageTrigger2.default((0, _get2.default)('displayOnScrollPercentage', clientTriggersData)),
    displayOnTimeDelay: new _TimeDelayTrigger2.default((0, _get2.default)('displayOnTimeDelay', clientTriggersData)),
    displayOnExitIntent: new _ExitIntentTrigger2.default((0, _get2.default)('displayOnExitIntent', clientTriggersData))
  });
};